import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0D1117', padding: 20,
    }}>
      <div style={{
        width: '100%', maxWidth: 380,
        background: '#161B22', border: '1px solid #21262D',
        borderRadius: 14, padding: 36,
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 52, height: 52, margin: '0 auto 14px',
            background: 'linear-gradient(135deg, #2A2010 0%, #1A1508 100%)',
            borderRadius: 14,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Gear / cog at top */}
              <circle cx="16" cy="5.5" r="2.5" stroke="#C9A84C" strokeWidth="1.5"/>
              <circle cx="16" cy="5.5" r="1" fill="#C9A84C"/>
              {/* Person body */}
              <circle cx="16" cy="13" r="2.2" stroke="#C9A84C" strokeWidth="1.4"/>
              <path d="M16 15.5 L16 21" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
              <path d="M16 21 L13 26" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
              <path d="M16 21 L19 26" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
              {/* Arms */}
              <path d="M16 17 L10 14" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
              <path d="M16 17 L22 14" stroke="#C9A84C" strokeWidth="1.4" strokeLinecap="round"/>
              {/* Clipboard left-far */}
              <rect x="3" y="11" width="6" height="7" rx="1" stroke="#C9A84C" strokeWidth="1.3"/>
              <path d="M5 14.5 L5.8 15.5 L7.5 13.5" stroke="#C9A84C" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
              {/* Clipboard left-near */}
              <rect x="7.5" y="19" width="5.5" height="6.5" rx="1" stroke="#C9A84C" strokeWidth="1.3"/>
              <path d="M9 22 L9.7 23 L11.5 21" stroke="#C9A84C" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
              {/* Clipboard right-near */}
              <rect x="19" y="19" width="5.5" height="6.5" rx="1" stroke="#C9A84C" strokeWidth="1.3"/>
              <path d="M20.5 22 L21.2 23 L23 21" stroke="#C9A84C" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
              {/* Clipboard right-far */}
              <rect x="23" y="11" width="6" height="7" rx="1" stroke="#C9A84C" strokeWidth="1.3"/>
              <path d="M24.5 14.5 L25.3 15.5 L27 13.5" stroke="#C9A84C" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div style={{ color: '#E6EDF3', fontWeight: 700, fontSize: 18 }}>
            Planning Intelligence
          </div>
          <div style={{ color: '#8B949E', fontSize: 12, marginTop: 4, fontFamily: 'IBM Plex Mono, monospace' }}>
            dataintelligence.md · TV & Digital
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', color: '#8B949E', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>
              Email
            </label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              autoFocus required
              style={{
                width: '100%', padding: '10px 12px',
                background: '#0D1117', border: '1px solid #21262D',
                borderRadius: 8, color: '#E6EDF3', fontSize: 14,
                outline: 'none',
              }}
              onFocus={e => e.target.style.borderColor = '#C9A84C'}
              onBlur={e => e.target.style.borderColor = '#21262D'}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', color: '#8B949E', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 12px',
                background: '#0D1117', border: '1px solid #21262D',
                borderRadius: 8, color: '#E6EDF3', fontSize: 14, outline: 'none',
              }}
              onFocus={e => e.target.style.borderColor = '#C9A84C'}
              onBlur={e => e.target.style.borderColor = '#21262D'}
            />
          </div>

          {error && (
            <div style={{
              background: 'rgba(248,81,73,0.1)', border: '1px solid rgba(248,81,73,0.3)',
              borderRadius: 7, padding: '10px 14px', marginBottom: 16,
              color: '#F85149', fontSize: 13,
            }}>{error}</div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '11px',
              background: loading ? '#21262D' : 'linear-gradient(135deg, #C9A84C, #B8973B)',
              border: 'none', borderRadius: 8, color: '#0D1117',
              fontWeight: 700, fontSize: 14, cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all .15s',
            }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop: 20, textAlign: 'center', color: '#484F58', fontSize: 11, fontFamily: 'IBM Plex Mono, monospace' }}>
          TV Planning · Digital Planning
        </div>
      </div>
    </div>
  );
}
